import { Component, OnInit, ɵɵcontainerRefreshEnd } from '@angular/core';
import "./webcam.component.scss";
import * as PhotoSwipe from "photoswipe";
import * as PhotoSwipeUI_Default from './../../../node_modules/photoswipe/dist/photoswipe-ui-default';
import * as $ from 'jquery';

@Component({
  selector: 'webcam-element',  
  templateUrl: './webcam.component.html'
})

export class WebcamComponent implements OnInit {

  webcams!: any[];
  
  constructor(){
     this.webcams = [
       { name: "Påstiging", url: 'https://restreamer.hornindalski.no/snap.jpeg', w:2688, h:1512 },
       { name: "Nedfart", url: 'https://webcam.rbt.no/hornindalski-nedfart.jpg', w:1920, h: 1080},
       { name: "Toppavstiging", url: 'https://webcam.rbt.no/hornindalski-avstigning.jpg', w:1920, h: 1080}
     ]
  }

  ngOnInit(): void {
    this.load();

    var hash = location.hash.substr(1);
    for (let webcam of this.webcams) {
      if (hash == this.getUrlFriendly(webcam.name)) {
        this.photoswipe(webcam);
        break;
      }
    }

  }  

  load(): void {
    for(let webcam of this.webcams) {
      if (!webcam.images) {
        webcam.images = [];
      }
      webcam.images.push({ url: webcam.url + "?" + new Date().getTime(), opacity: (webcam.images.length == 0 ? '1' : '0') });
      
      for (let image of webcam.images) {
        setTimeout( () => { image.opacity = 1; }, 2000);
      }

      if (webcam.images.length > 2)
        webcam.images.splice(0, webcam.images.length - 2);
    }

    setTimeout(() => this.load(), 30*1000);  
  }

  photoswipe(webcam) {

      var pswpElement = document.querySelectorAll('.pswp')[0] as HTMLElement;

      // build items array
      var items = [
          {
              src: webcam.images[webcam.images.length - 1].url,
              w: webcam.w,
              h: webcam.h,
              title: '<strong>Hornindal Skisenter</strong>: ' +  webcam.name,
              pid: webcam.name
          }
      ];
      
      // define options (if needed)
      var options = {
          // optionName: 'option value'
          // for example:
          index: 0 // start at first slide
      };
      
      // Initializes and opens PhotoSwipe
      var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();

      location.replace("#" + this.getUrlFriendly(webcam.name));

      var refreshTimeout = setTimeout( () => {       
        refresh();
      }, 30*1000);

      let refresh = function() {
        var url = $('img.pswp__img').attr("src").split("?")[0] + "?" + new Date().getTime();
        $('img.pswp__img').attr("src", url);
        refreshTimeout = setTimeout( () => refresh(), 30*1000 );
      }

      gallery.listen('close', function() { 
        clearTimeout(refreshTimeout);
        setTimeout( () => {
          history.replaceState(null, null, ' ');
        }, 500);
      }); 
  } 

  getUrlFriendly(str :string) {
    return str.toLowerCase().replace("å","a").replace("ø", "o").replace("æ", "ae");
  }

}
